import { c as _c } from "react/compiler-runtime";
import { FeatherDownload, FeatherRotateCcw, FeatherTrash2 } from '@subframe/core';
import * as SubframeCore from '@subframe/core';
import { Button, DropdownMenu } from '@/shared/components/ui';
import type { SimulacaoActionsProps } from '../types';
export const SimulacaoActions = t0 => {
  const $ = _c(25);
  const {
    started,
    restartDisabled,
    hasMessages,
    hasVisibleMessages,
    onClear,
    onRestart,
    onDownload
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FeatherDownload />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = !hasMessages;
  let t3;
  if ($[1] !== t2) {
    t3 = <SubframeCore.DropdownMenu.Trigger asChild={true}><Button variant="neutral-secondary" size="small" icon={t1} disabled={t2}>Baixar conversa</Button></SubframeCore.DropdownMenu.Trigger>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== onDownload) {
    t4 = <DropdownMenu.DropdownItem onClick={() => onDownload("md")}>Baixar em Markdown (.md)</DropdownMenu.DropdownItem>;
    $[3] = onDownload;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== onDownload) {
    t5 = <DropdownMenu.DropdownItem onClick={() => onDownload("pdf")}>Baixar em PDF (.pdf)</DropdownMenu.DropdownItem>;
    $[5] = onDownload;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <SubframeCore.DropdownMenu.Portal><SubframeCore.DropdownMenu.Content align="end" className="animate-fade-in"><DropdownMenu>{t4}{t5}</DropdownMenu></SubframeCore.DropdownMenu.Content></SubframeCore.DropdownMenu.Portal>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t6) {
    t7 = <SubframeCore.DropdownMenu.Root>{t3}{t6}</SubframeCore.DropdownMenu.Root>;
    $[10] = t3;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <FeatherTrash2 />;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = !hasVisibleMessages;
  let t10;
  if ($[14] !== onClear || $[15] !== t9) {
    t10 = <Button variant="neutral-secondary" size="small" icon={t8} disabled={t9} onClick={onClear}>Limpar</Button>;
    $[14] = onClear;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <FeatherRotateCcw />;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  const t12 = !started || restartDisabled;
  let t13;
  if ($[18] !== onRestart || $[19] !== t12) {
    t13 = <Button variant="neutral-secondary" size="small" icon={t11} disabled={t12} onClick={onRestart}>Reiniciar</Button>;
    $[18] = onRestart;
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t10 || $[22] !== t13 || $[23] !== t7) {
    t14 = <div className="flex flex-wrap items-center gap-2">{t7}{t10}{t13}</div>;
    $[21] = t10;
    $[22] = t13;
    $[23] = t7;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  return t14;
};